import addHolidayDialogTemplate from "./addHolidayDialog/addHolidayDialog.html";
import addHolidayDialogController from "./addHolidayDialog/addHolidayDialog.controller";
import { formatDate } from "../../core/utils";

class Controller {
  constructor(
    Events,
    $state,
    $location,
    Sections,
    $stateParams,
    $mdDialog,
    Messages,
    Holiday
  ) {
    "ngInject";

    this.Events = Events;
    this.$state = $state;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.Messages = Messages;
    this.$mdDialog = $mdDialog;

    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;
    this.Holiday = Holiday;

    this.filterEvent = this.Events.getFilterEvent("holidays");
    this.paginateEvent = this.Events.getPaginateEvent("holidays");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  openDialog() {
    this.$mdDialog
      .show({
        controller: addHolidayDialogController,
        controllerAs: "$ctrl",
        template: addHolidayDialogTemplate,
        locals: {},
      })
      .then(({ name, city: { _id }, date }) => {
        this.Holiday.post({ name, city: _id, date: formatDate(date) })
          .$promise.then(({ _id: id }) => {
            this.Events.emit(
              this.successNotificationEvent,
              this.Messages.addMessage("Holiday")
            );
            this.$state.transitionTo("holiday", {
              id,
            });
          })
          .catch((err) => {
            this.Events.emit(this.errorNotificationEvent, err.data);
          });
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/holidays/holidays.controller.js